import React from 'react'
import { ParentProfile } from '../__generated__/types'

export const ProfileContext = React.createContext<ParentProfile | null>(null)
